<template>
    <el-dialog title="引导关注二维码" :visible.sync="centerDialogVisible" width="600px" class="noBuyCode">
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <div class="openClose">
            <p class="title">引导关注</p>
            <el-radio-group v-model="noBuyData.isOpen">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
            <span class="tips">开启后，在店铺详情页会显示引导关注入口 </span>
        </div>
        <div class="codeName">
            <p class="title">二维码名称</p>
            <el-input v-model.trim="noBuyData.codeName" :disabled="noBuyData.isOpen === 0" placeholder="请输入二维码名称" maxlength="10" show-word-limit></el-input>
        </div>
        <div class="noBuyCodeBox">
            <p class="title">公众号二维码</p>
            <div class="upload cover-image" @click="openDialog">
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text">
                        <img class="uploadImgIcon" :src="require('@/common/images/other/upload.png')" v-if="!img" alt="">
                        <img :src="img.furl +'?'+timestamp" alt="" class="uploadImg" v-else-if="img.furl &&  img.furl + '?' + timestamp">
                        <img :src="img + '?'+timestamp" alt="" class="uploadImg" v-else>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {mapGetters, mapActions} from 'vuex'
import {updateShopSet} from 'api/accountApi'
export default {
    name: 'noBuyCode',
    data() {
        return {
            centerDialogVisible: false,
            img: '',
            noBuyData: {
                isOpen: 1,
                codeName: ''
            },
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [110, 110], // 截图框的宽高比例
                enlarge: 2.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 110, // 默认生成截图框宽度
                autoCropHeight: 110 // 默认生成截图框高度
            }
        }
    },
    props: ['data'],
    methods: {
        openDialog() {
            if (this.noBuyData.isOpen === 1) {
                this.$refs.localCropper.openDialog()
            } else {
                this.$message.error('需要开启后才可上传')
            }
        },
        _setImage(file) {
            this.timestamp = new Date().getTime()
            this.img = file
        },
        confirm() {
            if (this.noBuyData.isOpen === 1) {
                if (this.img) {
                    if (this.img.furl) {
                        delete this.img.type
                        this.img = JSON.stringify(this.img)
                    } else {
                        this.img = ''
                    }
                    this.setLoading(true)
                    updateShopSet({
                        data: {issubscribe: this.noBuyData.isOpen, subqrcodename: this.noBuyData.codeName, subqrcodeinfo: this.img},
                        success: data => {
                            this.setLoading(false)
                            this.centerDialogVisible = false
                            this.$message.success('设置成功')
                            this.$emit('getMsg')
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    this.$message.error('请上传二维码')
                }
            } else {
                this.setLoading(true)
                updateShopSet({
                    data: {issubscribe: this.noBuyData.isOpen, subqrcodename: '', subqrcodeinfo: ''},
                    success: data => {
                        this.setLoading(false)
                        this.centerDialogVisible = false
                        this.$message.success('设置成功')
                        this.$emit('getMsg')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        ShopLocalCropper
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    this.noBuyData.isOpen = newV.issubscribe
                    this.noBuyData.codeName = newV.subqrcodename
                    this.img = newV.subqrcodeurl
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .noBuyCode{
        .title{
            width: 98px;
        }
        .openClose{
            display: flex;
            margin-bottom: 15px;
            .el-radio-group{
                margin-left: 40px;
                .el-radio__input.is-checked+.el-radio__label{
                    color: #303133;
                }
            }
            .tips{
                margin-left: 10px;
                color: #909399;
            }
        }
        .codeName{
            display: flex;
            margin-bottom: 15px;
            align-items: center;
            .el-input{
                margin-left: 40px;
                width: 400px;
            }
        }
        .noBuyCodeBox{
            display: flex;
            justify-content: flex-start;
            .upload{
                margin-left: 40px;
                .avatar-uploader{
                    display: flex;
                    .el-upload{
                        width: 110px;
                        height: 110px;
                        margin-right: 10px;
                        background: #F5F7FA;
                        line-height: 110px;
                        text-align: center;
                        .uploadImgIcon{
                            width: 21px;
                            height: 21px;
                        }
                        .uploadImg{
                            width: 110px;
                            height: 110px;
                        }
                    }
                    .el-upload__tip{
                        color: #C0C4CC;
                        font-size: 14px;
                    }
                }
            }
        }
    }
</style>
